import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import LeftDrawer from './LeftDrawer';
import Header from './Header';

import styles from './styles';

const drawerWidth = 240;

class Dashboard extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      open: false,

    };

  }

  componentDidMount() {

    window.addEventListener('resize', this.resize.bind(this));
    this.resize();

  }

  resize() {

    this.setState({ open: window.innerWidth >= 760 });

  }

  onToggleDrawer = () => {

    this.setState(prevState => ({
      open: !prevState.open,
    }));


  };


  render() {

    const { classes, openRoute } = this.props;

    const { open } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <Header classes={classes} open={open} toggleDrawer={this.onToggleDrawer} />

          <LeftDrawer
            open={open}
            classes={classes}
            toggleDrawer={this.onToggleDrawer}

          />
          <main className={classes.content} style={{paddingLeft: open? drawerWidth * 1.05 : drawerWidth * 0.35}}>
            <div className={classes.appBarSpacer} />
            {openRoute}
          </main>
        </div>
      </React.Fragment>
    );

  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  openRoute: PropTypes.any,
};

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js